// removed by extract-text-webpack-plugin
module.exports = {"imageModalError":"styles__imageModalError___AbWpJ","btnModalError":"styles__btnModalError___2U8FO","failedInvoices":"styles__failedInvoices___3rim8"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ModalError/styles.css
// module id = 2753
// module chunks = 0